import 'css-chunksrc/client/pages/projectPage/kanbanPage/styles.scss';export default {
  "kanbanPage": "_kanbanPage_1rnos_1",
  "columns": "_columns_1rnos_6",
  "column": "_column_1rnos_6",
  "statusCreationForm": "_statusCreationForm_1rnos_18",
  "loader": "_loader_1rnos_23",
  "loaderMain": "_loaderMain_1rnos_31",
  "filters": "_filters_1rnos_38",
  "dropZone": "_dropZone_1rnos_42",
  "dropBox": "_dropBox_1rnos_48",
  "dropBoxReverse": "_dropBoxReverse_1rnos_52",
  "hideColumnContent": "_hideColumnContent_1rnos_57",
  "dragged": "_dragged_1rnos_61",
  "collapseColumn": "_collapseColumn_1rnos_66"
};